import { render, staticRenderFns } from "./BusinessOpportunityOpen.vue?vue&type=template&id=c8a9d2d6&"
import script from "./BusinessOpportunityOpen.vue?vue&type=script&lang=js&"
export * from "./BusinessOpportunityOpen.vue?vue&type=script&lang=js&"
import style0 from "./BusinessOpportunityOpen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports